/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */

import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ProductId } from "./../models/product-home-interface";
import { from, Observable, Subject, BehaviorSubject } from "rxjs";
import { API_PATH } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class ProductHomeService {
  public noOfLikes: number;
  public noOfDislikes: number;

  // private _likeIsClicked =new Subject<any>();;
  // likeIsClicked= this._likeIsClicked.asObservable();
  public likeClicked: boolean = false;
  public unlikeClicked: boolean = false;
  productAnchor;
  public stack: any[];
  public j;
  top = -1;
  private _urlrating = "/assets/producy-test-data.json";
  private _url = "/assets/product-test-data.json";
  public onClickProd = false;
  public clickedModel: any;
  public newmodel: any;
  public likeD = 0;
  public scanProductId;
  public dislikeD = 0;
  public likeFlag = false;
  public dislikeFlag = false;
  currentPosition: number;
  throwSimilarImage: BehaviorSubject<any> = new BehaviorSubject([]);
  throwProductImage: BehaviorSubject<any> = new BehaviorSubject([]);
  throwRating: BehaviorSubject<number> = new BehaviorSubject(0);
  getFooterImageId: BehaviorSubject<string> = new BehaviorSubject("");
  toProductHome: BehaviorSubject<any> = new BehaviorSubject({});
  throwProductStoryId: BehaviorSubject<any> = new BehaviorSubject([]);
  throwProductDialogDetails: BehaviorSubject<any> = new BehaviorSubject([]);
  throwProductDetails: BehaviorSubject<any> = new BehaviorSubject({});
  throwBackUrl: BehaviorSubject<string> = new BehaviorSubject("");
  throwFavourites: BehaviorSubject<any> = new BehaviorSubject([]);
  throwUpdatedUser: BehaviorSubject<any> = new BehaviorSubject({});
  togglelike() {
    if (!this.likeFlag) {
      if (this.likeClicked === true) {
        this.likeD++;
        this.noOfLikes++;
        this.unlikeClicked = false;
        this.likeFlag = true;
      }
    }
    if (this.likeFlag) {
      if (this.likeClicked === true) {
        this.likeD++;
        this.noOfLikes++;
        this.unlikeClicked = false;
        if (!(this.likeD % 2)) {
          this.noOfDislikes--;
        }
      }
    }
  }
  toggleunlike() {
    if (!this.dislikeFlag) {
      if (this.unlikeClicked === true) {
        this.dislikeD++;
        this.noOfDislikes++;
        this.likeClicked = false;
        this.dislikeFlag = true;
      }
    }
    if (this.dislikeFlag) {
      if (this.unlikeClicked === true) {
        this.dislikeD++;
        this.noOfDislikes++;
        this.likeClicked = false;
        if (!(this.dislikeD % 2)) {
          this.noOfLikes--;
        }
      }
    }
    console.log("indkfdkfjdkf", this.likeClicked, this.unlikeClicked);
  }
  push(i) {
    this.top += 1;
    this.stack[this.top] = i;
  }
  pop() {
    this.j = this.stack[this.top];
    this.stack[this.top] = null;
    this.top -= 1;
    return this.j;
  }
  public backButtonStack: any[];
  top1 = -1;

  constructor(private http: HttpClient) {}
  // likeDislike(likeisClicked: any) {
  //   this._likeIsClicked.next(likeisClicked);
  // }
  // getRating(): Observable<Product[]> {
  //   return this.http.get<Product[]>(this._urlrating);
  // }
  // getDetails(): Observable<Product[]> {
  //   return this.http.get<Product[]>(this._url);
  // }
  getEvidences() {
    return this.http.get<any>(`${API_PATH.apis.getEvidences}`);
  }
  getStories() {
    return this.http.get<any>(`${API_PATH.apis.getStories}`);
  }
}
